import { Stack, styled } from '@mui/material'
import { Flex, FlexBetween, FlexColumn, FlexStart, SectionWrap } from 'styles'
import { TrendColorizerText } from '../../../components/TrendColorizer'

export const MarketHeaderWrap = styled(SectionWrap)`
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 68px;
  padding: 0 20px;
  position: relative;

  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 120px;
    padding: 18px 16px;
    flex-wrap: wrap;
    align-items: flex-start;
    border: none;
    background: none;
    margin-bottom: 0;
    justify-content: space-between;
    flex-direction: column;
  }
`
export const MarketStart = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`
export const SelectMarket = styled(FlexBetween)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.text90};
  cursor: pointer;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 0;
    min-width: unset;
    width: auto;
  }
`
export const CurrentMarket = styled('div')`
  gap: 4px;
  color: rgba(202, 213, 220, 1);
  font-size: 18px;
  font-weight: 600;
`
export const SymbolName = styled(Flex)`
  align-items: center;
  line-height: 24px;
`
export const BaseName = styled(FlexStart)``
export const QuoteName = styled('div')`
  white-space: nowrap;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`
export const SymbolArrowDown = styled('span')`
  margin: 0 8px;
  line-height: 0;
`
export const Line = styled('div')`
  width: 1px;
  height: 36px;
  background: ${({ theme }) => theme.color.text10};
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
export const LastPrice = styled(Stack)`
  width: unset;
  flex: unset;
  align-items: self-start;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: auto;
    align-items: flex-start;
    justify-content: flex-start;
  }
`
export const LastPriceHolder = styled('div')`
  font-weight: 600;
  vertical-align: text-bottom;
`
export const LastPriceText = styled(TrendColorizerText)`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
`
export const LastPriceText2Usd = styled('div')`
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  margin-top: 2px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
export const LastPriceChange = styled(TrendColorizerText)`
  display: none;
  font-weight: 600;
  font-size: 16px;
  ${({ theme }) => theme.breakpoints.down('xl')} {
    display: block;
    font-size: 14px;
  }
`
export const StatsItem = styled(FlexColumn)`
  color: ${({ theme }) => theme.color.text50};
  font-size: 14px;
  line-height: 16px;
  padding: 0 0 0 20px;
  white-space: nowrap;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex: 1;
    padding-left: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${(props) => props.theme.color.text50};
    width: auto;
    align-items: flex-start;
    &:nth-of-type(2n) {
      justify-content: end;
    }
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 0;
    flex: unset;
    width: unset;
  }
  b {
    display: inline-block;
    font-size: 14px;
    line-height: 16px;
    margin-top: 4px;
    color: ${({ theme }) => theme.color.text90};
    font-weight: 600;
    ${({ theme }) => theme.breakpoints.down('md')} {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
  }
`
export const MarketChange = styled(TrendColorizerText)`
  display: inline-block;
  font-size: 14px;
  line-height: 16px;
  margin-top: 4px;
  font-weight: 600;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
`
export const OpenInterest = styled(StatsItem)`
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: none;
  }
`
export const DailyChange = styled(StatsItem)`
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: none;
  }
`
